const getExplicitZIndex = (annotation) => {
  const zIndex = annotation?.zIndex;
  return typeof zIndex === 'number' && Number.isFinite(zIndex) ? zIndex : null;
};

const getLegacyStackPriority = (annotation) => {
  if (annotation?.name === 'Text') {
    return 1;
  }
  return 0;
};

import { tagTextBackgroundCardRects } from './annotationGroupUtils';

const normalizeLoadedAnnotationsStacking = (annotations = {}) => {
  const tagged = tagTextBackgroundCardRects(annotations);
  const entries = Object.entries(tagged);
  if (entries.length < 2) {
    return tagged;
  }

  return Object.fromEntries(
    entries
      .map(([id, annotation], originalIndex) => ({
        id,
        annotation,
        originalIndex,
        explicitZIndex: getExplicitZIndex(annotation),
      }))
      .sort((a, b) => {
        if (a.explicitZIndex !== null || b.explicitZIndex !== null) {
          return (a.explicitZIndex ?? a.originalIndex) - (b.explicitZIndex ?? b.originalIndex);
        }

        const priorityDiff =
          getLegacyStackPriority(a.annotation) - getLegacyStackPriority(b.annotation);
        return priorityDiff || a.originalIndex - b.originalIndex;
      })
      .map(({ id, annotation }) => [id, annotation]),
  );
};

export default normalizeLoadedAnnotationsStacking;
